import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isMutating", "emptyContent", "rowProps", "onRowClick"];
import * as React from 'react';
import { isEqual, omit } from 'lodash';
import { Box, CircularProgress, Table as MuiTable, TableContainer } from '@lumahealthhq/ui-core';
import { useUniqueId } from '@lumahealthhq/ui-utils';
import { useDataResourceContext } from '../../contexts/DataResourceContext';
import EmptyContent from '../EmptyContent';
import TableBody from '../TableBody';
import TableHeaders from '../TableHeaders';
import { TableEmptyContent } from './components';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Table(_ref) {
  let {
      isMutating,
      emptyContent,
      rowProps,
      onRowClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    withCheckbox,
    children,
    tableContainerProps
  } = props;
  const elementId = useUniqueId();
  const {
    isLoading,
    data,
    page
  } = useDataResourceContext();
  const isEmpty = !data.length;
  const firstElementRef = React.useRef(null);
  const initialFilters = React.useRef(props.params);
  const isFiltered = !isEqual(initialFilters.current, props.params);
  React.useEffect(() => {
    if (page) {
      var _firstElementRef$curr;
      firstElementRef == null ? void 0 : (_firstElementRef$curr = firstElementRef.current) == null ? void 0 : _firstElementRef$curr.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }, [page]);
  const tableProps = React.useMemo(() => omit(props, ['withSearch', 'withCheckbox', 'groupMenuOptions', 'paginationOptions', 'sortOptions', 'model', 'postFix', 'queryOptions', 'tableContainerProps', 'isLoading', 'renderLabel']), [props]);
  return /*#__PURE__*/_jsxs(TableContainer, _extends({}, tableContainerProps, {
    id: elementId,
    children: [isMutating && /*#__PURE__*/_jsx(Box, {
      sx: {
        position: 'absolute',
        display: 'flex',
        inset: 0,
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none'
      },
      children: /*#__PURE__*/_jsx(CircularProgress, {
        color: "primary",
        size: 20,
        sx: {
          zIndex: 30
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      ref: firstElementRef
    }), /*#__PURE__*/_jsxs(MuiTable, _extends({
      size: "small",
      stickyHeader: true
    }, tableProps, {
      children: [/*#__PURE__*/_jsx(TableHeaders, {
        withCheckbox: withCheckbox,
        children: children
      }), /*#__PURE__*/_jsx(TableBody, {
        parentId: elementId,
        parentChildren: children,
        withCheckbox: withCheckbox,
        isLoading: isLoading,
        rowProps: rowProps,
        onRowClick: onRowClick
      })]
    })), !isLoading && isEmpty && /*#__PURE__*/_jsx(EmptyContent, {
      children: emptyContent != null ? emptyContent : /*#__PURE__*/_jsx(TableEmptyContent, {
        isFiltered: isFiltered
      })
    })]
  }));
}
export default Table;